import { render } from "./travelLogisticMobilityActivityRecorder.vue?vue&type=template&id=01b1797f&scoped=true&ts=true"
import script from "./travelLogisticMobilityActivityRecorder.vue?vue&type=script&lang=ts"
export * from "./travelLogisticMobilityActivityRecorder.vue?vue&type=script&lang=ts"

import "./travelLogisticMobilityActivityRecorder.vue?vue&type=style&index=0&id=01b1797f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b1797f"]])

export default __exports__